module.exports = __webpack_public_path__ + "static/media/shells_header_tablet.715bcf8c.png";